import { IEvaluator } from "../SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareEvaluatorAttributePropertyValues =
    AttributePropertyValues
    & {
        evaluator: IEvaluator;
    };

export type ClientAwareEvaluatorAttributeProperties = {
    [name in keyof ClientAwareEvaluatorAttributePropertyValues]?: ClientAwareEvaluatorAttributePropertyValues[name];
};

export interface IClientAwareEvaluatorAttribute extends IAttribute, ClientAwareEvaluatorAttributeProperties
{
}

export class ClientAwareEvaluatorAttribute extends Attribute implements IClientAwareEvaluatorAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareEvaluatorAttribute";
    public static override className = "ClientAwareEvaluatorAttribute";

    public evaluator?: IEvaluator;

    constructor(propertyValues?: Partial<ClientAwareEvaluatorAttributePropertyValues>)
    {
        super(propertyValues);

        this.evaluator = propertyValues?.evaluator;
    }
}